export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-copy-9ed5644423c04971d8108c8a64ebd81e.svg";